import apiFetch from '../../apiFetch'

export default function (purchaseId, token) {
  return apiFetch({ endPoint: `dossier/purchase/${purchaseId}/uac`, method: 'GET', token: token })
}
